// @ts-nocheck
import * as React from 'react';
import Lottie from 'react-lottie';
// Components
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import AppBar from 'components/AppBar';
import NooderaButton from 'components/NooderaButton';
import Dialog from '@mui/material/Dialog';

import type {
  NooderaModalProps,
  NooderaSmallModalProps,
  NooderaMediumModalProps,
} from './NooderaModal.types';
import {
  Content,
  SmallContent,
  ModalContent,
  ModalTitle,
  ModalImage,
  ModalDescription,
  ModalButtons,
  ModalLinkText,
  StyledDialog,
  MediumDialog,
  StyledDialogTitle,
  StyledDialogActions,
  SmallModalTopIcon,
  ModalCloseIconWrapper,
} from './NooderaModal.styles';

const NooderaModal = ({
  isOpen,
  title = '',
  hasAppBar = true,
  children,
  onClose,
}: NooderaModalProps): React.ReactElement<any> => (
  <Dialog
    fullScreen
    open={isOpen}
    onClose={onClose}
    role='dialog'
    aria-modal='true'
    aria-live='polite'
    aria-label={title}
  >
    {hasAppBar && <AppBar title={title} onClose={onClose} />}
    <Content hasAppBar={hasAppBar}>{children}</Content>
  </Dialog>
);
const Small = ({
  isOpen,
  icon,
  title,
  description,
  imageContent,
  className,
  linkText,
  btnText,
  onClose,
  onBtnClick,
  customBtns,
  hasCloseBtn,
  isButtonDisabled,
  role,
}: NooderaSmallModalProps): React.ReactElement<any> => {
  const baseId = 'modal';
  const modalTitleId = `${baseId}-title-${title.replace(/\s/g, '')}`;
  const modalDescriptionId = `${baseId}-description-${title.replace(/\s/g, '')}`;

  return (
    <StyledDialog
      className={className}
      open={isOpen}
      onClose={onClose}
      role={role ?? 'alertdialog'}
      aria-live='assertive'
      aria-modal='true'
      aria-labelledby={modalTitleId}
      aria-describedby={modalDescriptionId}
    >
      {hasCloseBtn && (
        <ModalCloseIconWrapper>
          <NooderaButton.RoundCTA onClick={onClose} size='small' aria-label='Close'>
            <CloseIcon />
          </NooderaButton.RoundCTA>
        </ModalCloseIconWrapper>
      )}
      <SmallContent>
        <ModalContent>
          <SmallModalTopIcon>{icon}</SmallModalTopIcon>
          <ModalTitle id={modalTitleId}>{title}</ModalTitle>
          {imageContent && (
            <ModalImage aria-hidden='true'>
              <Lottie
                className='lottie'
                options={{
                  loop: false,
                  autoplay: true,
                  animationData: imageContent,
                  rendererSettings: {
                    preserveAspectRatio: 'xMidYMid slice',
                  },
                }}
              />
            </ModalImage>
          )}
          <ModalDescription id={modalDescriptionId}>
            <div>
              {description} {linkText ? <ModalLinkText>{linkText}</ModalLinkText> : null}
            </div>
          </ModalDescription>
        </ModalContent>
        <ModalButtons>
          {!customBtns ? (
            <NooderaButton.CTA
              size='large'
              onClick={onBtnClick ?? onClose}
              isDisabled={isButtonDisabled}
              aria-label={btnText}
              tabIndex={0}
            >
              {btnText}
            </NooderaButton.CTA>
          ) : (
            customBtns
          )}
        </ModalButtons>
      </SmallContent>
    </StyledDialog>
  );
};
const Medium = ({
  isOpen,
  title,
  children,
  footer,
  onClose,
  className,
  ...extraProps
}: NooderaMediumModalProps): React.ReactElement<any> => (
  <MediumDialog
    className={className}
    open={isOpen}
    onClose={onClose}
    {...extraProps}
    role='dialog'
    aria-modal='true'
    aria-live='polite'
    aria-labelledby={`title-${title.replace(/\s/g, '')}`}
  >
    <StyledDialogTitle
      id={`title-${title.replace(/\s/g, '')}`}
      sx={{
        m: 0,
        p: 2,
      }}
    >
      {title}
      {onClose ? (
        <NooderaButton.RoundCTA size='small' onClick={onClose} aria-label='close'>
          <CloseIcon />
        </NooderaButton.RoundCTA>
      ) : null}
    </StyledDialogTitle>
    <DialogContent dividers>{children}</DialogContent>
    {footer && <StyledDialogActions>{footer}</StyledDialogActions>}
  </MediumDialog>
);

NooderaModal.Small = Small;
NooderaModal.Medium = Medium;
export default NooderaModal;
